import { Textarea, TextInput } from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";

import ReportVesselInputs from "../../../../components/pages/Management/Reports/ReportVesselInputs";
import useGetAllYachts from "../../../../components/pages/Management/Yachts/useGetAllYachts";
import Select from "../../../../components/shared/_FormInputs/Select";
import Breadcrumbs from "../../../../components/shared/Breadcrumbs/Breadcrumbs";
import { Button } from "../../../../components/shared/Button/Button";
import {
  ButtonsWrapper,
  Divider,
  Flex,
  PageContainer,
} from "../../../../styled";
import { groupComboboxItems } from "../../../../utils";
import {
  AddReportContainer,
  LayoutReportContainer,
} from "../../../Reports/AddReport/addReport.styled";
import ReportInputs from "../../../../components/pages/Reports/AddReport/ReportInputs";
import { useGetApi } from "../../../../hooks";
import CheckboxGroup from "../../../../components/shared/_FormInputs/CheckboxGroup/CheckboxGroup";
import useIsFleet from "../../../../components/pages/Management/useIsFleet";

const AddVesselReport = () => {
  const { yachts } = useGetAllYachts();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const isFleet = useIsFleet();
  const parsedYachts = useMemo(() => {
    const mapped = yachts.map((yacht: any) => ({
      label: yacht.yachtname,
      value: yacht.yid,
      group: yacht.clientname,
    }));
    return groupComboboxItems([
      { label: "All", value: "*", group: "All" },
      ...mapped,
    ]);
  }, [yachts]);

  const { data, refetch } = useGetApi({
    request: "get-report",
    // mapper: mapData,
    fetchOnInit: false,
  });

  const methods = useForm({
    defaultValues: {
      name: "",
      desc: "",
      against: "0",
      vessel: {
        type: "0",
        status: "0",
        vessels: [],
        fields: [],
        dates: "",
        start: null,
        end: null,
      },
      logbooks: {
        type: "0",
        status: "0",
        vessels: [],
        dates: "",
        start: null,
        end: null,
        logbook: [{ label: "All", value: "*" }],
      },
    },
  });

  const { watch, handleSubmit, control, register, reset, setValue } = methods;
  const against = watch("against");
  useEffect(() => {
    reset();
    setValue("against", against);
  }, [against]);

  const handleCreateReport = (data: any) => {
    console.log(data);
  };

  return (
    <PageContainer>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(handleCreateReport)}>
          <Breadcrumbs border={false}>
            <ButtonsWrapper>
              <Button type="submit">Save</Button>
            </ButtonsWrapper>
          </Breadcrumbs>

          <AddReportContainer>
            <LayoutReportContainer style={{ padding: 20 }}>
              <Flex gap="xl">
                <TextInput {...register("name")} label="Report Name" />
                <Textarea
                  label="Description"
                  placeholder="Report description"
                  autosize={false}
                  minRows={2}
                  {...register("desc")}
                />
                <Select
                  control={control}
                  name="against"
                  maw={"200px"}
                  label="Report Against"
                  data={[
                    {
                      value: "0",
                      label: "Vessel",
                    },
                    {
                      value: "1",
                      label: "Logbooks",
                    },
                  ]}
                />
              </Flex>

              <Divider style={{ margin: 10, opacity: 0.3 }} />
              {against === "0" ? (
                <ReportVesselInputs
                  methods={methods}
                  setEndDate={setEndDate}
                  setStartDate={setStartDate}
                  yachts={parsedYachts}
                />
              ) : (
                <Flex>
                  <Flex style={{ flex: 2 }}>
                    <ReportInputs
                      data={data}
                      prefix="logbooks"
                      setStartDate={setStartDate}
                      setEndDate={setEndDate}
                      methods={methods}
                      hideNameAndDesc
                      disableL10
                    />
                  </Flex>

                  <div style={{ flex: 1 }}>
                    <CheckboxGroup
                      name="vessel.vessels"
                      title="Vessels"
                      control={control}
                      data={parsedYachts}
                      disabled={false}
                      grouped={!isFleet}
                    />
                  </div>
                </Flex>
              )}
            </LayoutReportContainer>
          </AddReportContainer>
        </form>
      </FormProvider>
    </PageContainer>
  );
};
export default AddVesselReport;
